// SwitchButton.jsx
import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Button } from "@mui/material";
import SwitchLessonsDrawer from "./SwitchLessonsDrawer"; // Adjust the import path as needed
import { lessonUrlMapping } from "./functions";
import { useNavigate } from "react-router-dom";
import { IconButton, Tooltip } from "@mui/material";
import RocketLaunchIcon from "@mui/icons-material/RocketLaunch";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

import DashboardIcon from "@mui/icons-material/Dashboard";

const SwitchButton = ({ user, styles, theme }) => {
  const [switchLessonDrawerOpen, setSwitchLessonDrawerOpen] = useState(false);
  const [isVisible, setIsVisible] = useState(false);

  const [isLektionerPath, setIsLektionerPath] = useState(false);
  const navigate = useNavigate();

  const [currentLessonType, setCurrentLessonType] =
    useState("RolePlayLesson.js");
  const location = useLocation();

  useEffect(() => {
    // Check if URL contains ?v=t or &v=t
    const hasVParam =
      location.search.includes("?v=t") || location.search.includes("&v=t");

    const pathParts = location.pathname.split("/");
    const isLektionerPath =
      pathParts.length >= 4 &&
      pathParts[1] === "app" &&
      pathParts[2] === "lektioner";

    setIsVisible(hasVParam);
    setIsLektionerPath(isLektionerPath);
    // Get URL parameters for lesson type
    const urlParams = new URLSearchParams(location.search);
    const typeParam = urlParams.get("type");

    // Get full URL path
    const fullPath = location.pathname;
    let lessonTypeToSet = "RolePlayLesson.js"; // Default

    if (typeParam === "factText") {
      lessonTypeToSet = "BasicReadingCompLessonVariantFactText.js";
    } else if (typeParam === "instructingText") {
      lessonTypeToSet = "BasicReadingCompLessonVariantInstructingText.js";
    } else if (typeParam === "explainingText") {
      lessonTypeToSet = "BasicReadingCompLessonVariantExplainingText.js";
    } else if (typeParam === "argumentativeText") {
      lessonTypeToSet = "BasicReadingCompLessonVariantArgumentativeText.js";
    } else if (typeParam === "descriptiveText") {
      lessonTypeToSet = "BasicReadingCompLessonVariantDescriptiveText.js";
    } else if (typeParam === "chronicle") {
      lessonTypeToSet = "BasicReadingCompLessonVariantChronicle.js";
    } else if (typeParam === "review") {
      lessonTypeToSet = "BasicReadingCompLessonVariantReview.js";
    } else if (typeParam === "interview") {
      lessonTypeToSet = "ConversationLessonVariantInterview.js";
    } else {
      // Simple direct check for each URL part in the full path
      if (fullPath.includes("/lasforstaelse")) {
        lessonTypeToSet = "BasicReadingCompLesson.js";
      } else if (fullPath.includes("/vision")) {
        lessonTypeToSet = "VisionAnalysis.js";
      } else if (fullPath.includes("/tidslinjer")) {
        lessonTypeToSet = "TimelineLesson.js";
      } else if (fullPath.includes("/tankekartor")) {
        lessonTypeToSet = "MindMapLesson.js";
      } else if (fullPath.includes("/escape-room")) {
        lessonTypeToSet = "EscapeRoomLesson.js";
      } else if (fullPath.includes("/bygg-tidslinjer")) {
        lessonTypeToSet = "TimelineBuilderLesson.js";
      } else if (fullPath.includes("/rollkort")) {
        lessonTypeToSet = "RolePlayLesson.js";
      } else if (fullPath.includes("/fiktiva-dagbocker")) {
        lessonTypeToSet = "DiaryLesson.js";
      } else if (fullPath.includes("/lektionsplan")) {
        lessonTypeToSet = "LessonPlanRevamp.js";
      } else if (fullPath.includes("/fiktiva-brev")) {
        lessonTypeToSet = "LettersLesson.js";
      } else if (fullPath.includes("/historisk-person")) {
        lessonTypeToSet = "HistoricPersonLesson.js";
      } else if (fullPath.includes("/litteraturskolan")) {
        lessonTypeToSet = "LiteratureSchool.js";
      } else if (fullPath.includes("/ordforstaelse")) {
        lessonTypeToSet = "WordCompLesson.js";
      } else if (fullPath.includes("/argumentera")) {
        lessonTypeToSet = "ArgumentationLesson.js";
      } else if (fullPath.includes("/fiktiva-nyhetsredaktionen")) {
        lessonTypeToSet = "NewsLesson.js";
      } else if (fullPath.includes("/generera-powerpoint")) {
        lessonTypeToSet = "PowerPointGenerator.js";
      } else if (fullPath.includes("/kreativ-lasforstaelse")) {
        lessonTypeToSet = "CreativeReadingCompLesson.js";
      } else if (fullPath.includes("/konversation")) {
        lessonTypeToSet = "ConversationLesson.js";
      } else if (fullPath.includes("/lasdetektiven")) {
        lessonTypeToSet = "DetectiveReadingCompLesson.js";
      } else if (fullPath.includes("/pa-sparet")) {
        lessonTypeToSet = "ClueGeneratorLesson.js";
      } else if (fullPath.includes("/jeopardy")) {
        lessonTypeToSet = "JeopardyLesson.js";
      } else if (fullPath.includes("/glosor-i-lador")) {
        lessonTypeToSet = "TermsGridLesson.js";
      } else if (fullPath.includes("/veckans-ord")) {
        lessonTypeToSet = "WeeklyWordsLesson.js";
      } else if (fullPath.includes("/tungvrickare")) {
        lessonTypeToSet = "TongueTwistersLesson.js";
      } else if (fullPath.includes("/grammatik")) {
        lessonTypeToSet = "GrammarLesson.js";
      } else if (fullPath.includes("/idiom")) {
        lessonTypeToSet = "IdiomsLesson.js";
      } else if (fullPath.includes("/mystiska-bilden")) {
        lessonTypeToSet = "MysticImageLesson.js";
      } else if (fullPath.includes("/hitta-orden")) {
        lessonTypeToSet = "FindWordsLesson.js";
      } else if (fullPath.includes("/bilda-ordet")) {
        lessonTypeToSet = "LetterBoxLesson.js";
      } else if (fullPath.includes("/skrivlektion")) {
        lessonTypeToSet = "WritingLesson.js";
      } else if (fullPath.includes("/fortsatt-berattelsen")) {
        lessonTypeToSet = "SentenceFinisherLesson.js";
      } else if (fullPath.includes("/berattande-text")) {
        lessonTypeToSet = "NarrativeLesson.js";
      } else if (fullPath.includes("/grej-of-the-day")) {
        lessonTypeToSet = "GrejOfTheDay.js";
      }
    }
    // Update state with detected lesson type
    setCurrentLessonType(lessonTypeToSet);

    console.log("URL path:", fullPath);
    console.log("Set lesson type to:", lessonTypeToSet);
  }, [location]);

  const handleGoBack = () => {
    // Get base URL without parameters
    //const baseUrl = location.pathname.split("/").slice(0, -1).join("/");
    navigate(-1);
  };

  const buttonStyle = {
    position: "fixed",
    top: "20px",
    left: "20px",
    zIndex: 1000,
  };

  const buttonStyle2 = {
    position: "absolute",
    top: "20px",
    right: "75px",
    zIndex: 1000,
  };

  return (
    <>
      {isVisible && (
        <div style={buttonStyle}>
          {user.accountType === "teacher" &&
            !location.pathname.includes("/escape-room") &&
            !location.pathname.includes("/vision") && (
              <>
                <IconButton
                  color="text.secondary"
                  onClick={handleGoBack}
                  sx={{ marginRight: 1 }}
                >
                  <ArrowBackIcon />
                </IconButton>
              </>
            )}
        </div>
      )}
      {isLektionerPath && (
        <div style={{ ...buttonStyle2, display: "none" }}>
          {user.accountType === "teacher" &&
            !location.pathname.includes("/escape-room") &&
            !location.pathname.includes("/vision") && (
              <>
                <Tooltip title="Lektionsbanken">
                  <IconButton
                    onClick={() => setSwitchLessonDrawerOpen(true)}
                    sx={{ ...styles.iconButtonBg }}
                  >
                    <DashboardIcon />
                  </IconButton>
                </Tooltip>
              </>
            )}
        </div>
      )}

      <SwitchLessonsDrawer
        open={switchLessonDrawerOpen}
        onClose={() => setSwitchLessonDrawerOpen(false)}
        user={user}
        styles={styles}
        theme={theme}
        lessonType={currentLessonType}
      />
    </>
  );
};

export default SwitchButton;
